// The "web space" a practitioner may hang off their profile. Both editors (the
// mobile sheet and the desktop settings panel) accept a bare host and add the
// scheme, then check the result against the same pattern — a second copy of a
// 400-character regex is a second definition of what a link is.
const URL_PATTERN = String.raw`^(?:(?:http|https)://)(?:\S+(?::\S*)?@)?(?:(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z¡-￿0-9]+-?)*[a-z¡-￿0-9]+)(?:\.(?:[a-z¡-￿0-9]+-?)*[a-z¡-￿0-9]+)*(?:\.(?:[a-z¡-￿]{2,})))|localhost)(?::\d{2,5})?(?:(/|\?|#)[^\s]*)?$`;

/**
 * The link as it should be stored, or `null` for an empty field.
 *
 * `null` is "the practitioner typed nothing", which the API takes as "leave the
 * stored link alone" — the editors have never offered a way to clear one.
 */
export function formatProfileLink(input: string): string | null {
  if (input === "") return null;
  if (input.startsWith("http://") || input.startsWith("https://")) return input;
  return `https://${input}`;
}

export function isValidProfileLink(link: string): boolean {
  return new RegExp(URL_PATTERN, "i").test(link);
}
